import React from "react";
import {inject, observer} from "mobx-react";
import Header from "../../../sharedComponents/header/header";
import LegalGroup from "../../../sharedComponents/legalGroup/legalGroup";
import {ClientStore} from "../../../../stores/clientStore";
import LegalForm from "../../../sharedComponents/insurer/legalForm/legalForm";
import {ClientDataType, ClientModel, LegalFormClientData} from "../../../../helpers/client";
import IsInsurerAlsoInsured
    from "../../../sharedComponents/isInsurerAlsoInsured/isInsurerAlsoInsured";
import InsurerPersonData from "../../../../helpers/insurerPersonData";
import InsurerCompanyData from "../../../../helpers/insurerCompanyData";

interface InsurerProps {
    clientStore?: ClientStore;
}

@inject("clientStore")
@observer
export default class Insurer extends React.Component<InsurerProps> {

    public render() {
        const clientStore = this.props.clientStore!;
        const client = clientStore.insurer;
        const legalForm = clientStore.insurer.legalForm!;
        const clientDataType = LegalFormClientData[legalForm.value!];

        return (
            <div className="additional-questions-section insurer">
                <Header type="medium" mainHeader="Ubezpieczający (zawierający umowę)"/>
                <IsInsurerAlsoInsured disabled={false}/>
                <LegalGroup client={client}/>
                <LegalForm client={client}/>
                {(clientDataType === ClientDataType.PERSON ? this.renderPersonData(client) : "")}
                {(clientDataType === ClientDataType.COMPANY ? this.renderCompanyData(client) : "")}
                {(clientDataType === ClientDataType.PERSON_AND_COMPANY ? this.renderOtherData(client) : "")}
            </div>
        );
    }

    private renderPersonData(client: ClientModel) {
        return <InsurerPersonData client={client}
                                  recalculateOnChange={client.insurer}
                                  refreshRisks={true}/>;
    }

    private renderCompanyData(client: ClientModel) {
        return <InsurerCompanyData client={client} recalculate={client.insurer}/>;
    }

    private renderOtherData(client: ClientModel) {
        return <div className="other">
            {this.renderPersonData(client)}
            {this.renderCompanyData(client)}
        </div>;
    }
}
